import { createSelector } from 'reselect'
import { CommonState } from '~/store/types'

const selectUserInfoState = (state: CommonState) => state.userInfo || state.merchantInfo

const selectUserProfile = createSelector([selectUserInfoState], state => state.userProfile)

export const selectMerchantId = createSelector(
  [selectUserProfile],
  userProfile => userProfile?.merchantId
)
